import withWatchlist from 'src/components/filmwebid/withWatchlist';
import withWatchlistState from 'src/components/filmwebid/withWatchlistState';
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import WatchlistActionButton from 'src/components/kommendefilmer/WatchlistActionButton';
import Poster, { type PosterProps } from 'src/components/posterrow/Poster';
import { format, parseISO } from 'date-fns';
import locale from 'date-fns/locale/nb';
import { useLocationContext } from 'src/lib/contexts/LocationContext';
import { Movie } from 'src/lib/movieinfo/movieinfotypes';
import styles from './KommerPoster.module.css';

//#region [Props]
type KommerPosterProps = {
  dateFormat: 'thisweek' | 'thisyear' | 'year';
} & PosterProps;
//#endregion

const WLPoster = withWatchlist(Poster, 'film');
const WLSWatchlistButton = withWatchlistState(WatchlistActionButton);

//#region [Component]
export default function KommerPoster(props: KommerPosterProps) {
  const locContext = useLocationContext();
  const movie = props.film as Movie;
  if (!movie.premiere) {
    return null;
  }
  const premDate = parseISO(movie.premiere);
  let dateLabel: string;
  if (movie.isPremiereConfirmed) {
    switch (props.dateFormat) {
      case 'thisweek':
        dateLabel = format(premDate, 'EEEE dd.MM.', { locale });
        break;
      case 'thisyear':
        dateLabel = format(premDate, 'dd.MM.', { locale });
        break;
      case 'year':
        dateLabel = format(premDate, 'dd.MM.yyyy', { locale });
        break;
    }
  } else {
    dateLabel = format(premDate, 'MMMM yyyy', { locale });
  }

  return (
    <WLPoster
      className={styles.SWLPoster}
      posterMissingText="Plakat kommer"
      showMovieTitleIfPosterIsMissing
      {...props}
    >
      <div className={styles.SPremActions}>
        <div className={styles.SPremiere}>{dateLabel}</div>
        {(locContext.location && movie.showsCount > 0) || movie.showsCount > 10 ? (
          <FilmwebLink className={styles.STicketButton} to={`/film/${movie.mainVersionId}`}>
            Kjøp billetter
          </FilmwebLink>
        ) : (
          <WLSWatchlistButton edi={movie.mainVersionId} />
        )}
      </div>
    </WLPoster>
  );
}
//#endregion

